import React, { forwardRef } from "react";
import classNames from "classnames";
import { TextAreaStatus } from "./textarea-helper";

interface TextAreaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  /**
   * Extend classnames
   */
  extendClasses?: string;
  /**
   * Status
   */
  status?: TextAreaStatus;
}
const TextAreaRef: React.ForwardRefRenderFunction<
  HTMLTextAreaElement,
  TextAreaProps
> = ({ status, extendClasses, disabled, ...props }, ref) => (
  <textarea
    {...props}
    className={classNames({
      tfcTextArea: true,
      [`tfcTextArea-${status}`]: status,
      [`tfcTextArea-disabled`]: disabled,
      [extendClasses as string]: !!extendClasses,
    })}
    disabled={disabled}
    ref={ref}
  />
);

const TextArea = forwardRef(TextAreaRef);

export default TextArea;
